app.controller('ValueApartmentsSliderController',
	["$scope", function($scope) {
		$scope.slickBreakpoints = [
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		];
	}]
);